
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcTransformer as ObcTransformerElement} from '@oicl/openbridge-webcomponents/dist/automation/transformer/transformer.js';
 
 
 

 
 export const ObcTransformer = createComponent({
   react: React,
   tagName: 'obc-transformer',
   elementClass: ObcTransformerElement,
   events: {
     
   }
  });
 
 